import gql from 'graphql-tag';

export const SYNC_USER = gql`
  mutation syncUser($syncMasterTenant: Boolean) {
    syncUser(syncMasterTenant: $syncMasterTenant)
  }
`;
